import _ from "lodash";
import React from "react";
import Messages from "../Messages";
import timeAgo from "simple-timeago.handle-bad-input";
import MessageForm from "./MessageForm";
import "./MessagePreview.less";

export default React.createFactory(React.createClass({

  getInitialState: function () {
    return {
      show_reply: false,
      show_compliance_modal: false,
      sent_messages: []
    };
  },

  componentDidUpdate: function (prevProps) {
    let prev = _.map(_.filter(prevProps.thread, function (item) {
      return !_.get(item, ["receiver_opened"], false);
    }), "id");
    let next = _.map(_.filter(this.props.thread, function (item) {
      return !_.get(item, ["receiver_opened"], false);
    }), "id");
    //console.log("MessagePreview.js", "componentDidUpdate", prev, next);
    if (!_.isEqual(prev, next) && _.size(next)) {
      _.delay(this.__onMarkAsRead, 1000);
    }
    // _.delay(this.__onMarkAsRead, 5000);
  },

  __onShowReply: function () {
    this.setState({
      show_reply: !this.state.show_reply
    });
  },

  __onMarkAsRead: function (unread_ids) {
    //console.log("MessagePreview", "__onMarkAsRead", _.isFunction(this.props.onMarkAsRead), unread_ids);
    if (_.isFunction(this.props.onMarkAsRead)) {
      if (_.size(unread_ids) < 1) {
        unread_ids = _.map(_.filter(this.props.thread, function (item) {
          return !_.get(item, ["receiver_opened"], false);
        }), "id");
      }
      if (_.size(unread_ids) > 0) {
        return this.props.onMarkAsRead(unread_ids);
      }
    }
  },

  __onSentMessage: function (message) {
    if (_.isFunction(this.props.onSentMessage)) {
      this.props.onSentMessage(message);
    } else {
      this.setState({
        sent_messages: this.state.sent_messages.concat([message])
      });
    }
  },

  __onToggleComplianceModal: function() {
    if (_.isFunction(this.props.onShowComplianceModal)) {
      return this.props.onShowComplianceModal();
    }
  },

  render() {
    let {
      event_name,
      buyer_name,
      eid,
      sid,
      thread,
      has_compliance,
      show_send_form = true
    } = this.props;

    let received_date;
    let message = _.head(_.sortBy(thread, "sender_buyer_id").reverse());
    if (message) {
      if (!event_name) {
        event_name = _.get(message, ["organization"]);
      }
      if (!buyer_name) {
        buyer_name = _.get(message, ["buyer_name"]);
      }
      received_date = timeAgo(_.get(message, ["created"]));
    }

    thread = thread.concat(this.state.sent_messages);

    return (
        <div className="mp-message-preview">
          <div className="panel panel-default">
            <div className="panel-body">
              <div className="pull-right">
                <span className="sender-thumbnail"></span>
              </div>
              <div>
                <div className="sender-name">{buyer_name}</div>
                <span className="pull-right received-date">{received_date}</span>
              </div>
              <div>
                {event_name}
              </div>
              {!has_compliance &&
                <div>
                  <hr/>
                  <div className={"alert alert-warning"}>
                    <div className={"alert-content"}>
                      <p>
                        You have a message from the event organizer.  The directory managing this event requires you to accept their agreement before responding to the event organizer.
                      </p>
                      <br />
                      <div className={"btn btn-warning"} onClick={this.__onToggleComplianceModal}>Accept Agreement</div>
                    </div>
                  </div>
                </div>
              }
              {show_send_form && has_compliance && <div>
                <hr/>
                <div>
                  <MessageForm thread={thread} eid={eid} event={_.get(message, ["event"])} sid={sid} onSentMessage={this.__onSentMessage}/>
                </div>
              </div>
              }
            </div>
          </div>
          <div className="message-preview">
            <Messages messages={thread} onMarkAsRead={this.__onMarkAsRead} order={"desc"} blurMessages={!has_compliance} />
          </div>

        </div>
    );
  }
}));


// WEBPACK FOOTER //
// ./src/components/marketplace/MyMessagesTab/MessagePreview.js